import Aura from '@primeng/themes/aura';
import { definePreset } from '@primeng/themes';

export const LetpensionPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{lpprimary.50}',
      100: '{lpprimary.100}',
      200: '{lpprimary.200}',
      300: '{lpprimary.300}',
      400: '{lpprimary.400}',
      500: '{lpprimary.500}',
      600: '{lpprimary.600}',
      700: '{lpprimary.700}',
      800: '{lpprimary.800}',
      900: '{lpprimary.900}',
      950: '{lpprimary.950}',
    },
    colorScheme: {
      light: {
        text: {
          color: '{surface.950}',
        },
        primary: {
          color: '{lpprimary.500}',
          // inverseColor: '#ffffff',
          hoverColor: '{lpprimary.600}',
          activeColor: '{zinc.800}',
        },
        highlight: {
          background: '{lpprimary.500}',
          focusBackground: '{lpprimary.400}',
          color: '#ffffff',
          focusColor: '#ffffff',
        },
        formField: {
          hoverBorderColor: '{slate.400}',
          focusBorderColor: '{primary.color}',
          color: 'black',
          borderColor: '{slate:300}',
        },
      },
    },
  },
  components: {
    button: {
      root: {
        label: {
          fontWeight: '600',
        },
        paddingX: '16px',
      },
    },
    scrollpanel: {
      colorScheme: {
        light: {
          bar: {
            background: '#cccccc',
            size: '16px',
          },
        },
      },
    },
    datatable: {
      colorScheme: {
        light: {
          row: {
            stripedBackground: '#f5f5f5',
          },
          header: {
            color: '#000000',
          },
        },
      },
    },
    tabs: {
      tab: {
        fontWeight: '600',
        color: '#000000',
        activeColor: '#000000',
        activeBorderColor: '#49A3A8',
        borderColor: 'transparent',
        borderWidth: '0 0 4px 0',
      },
    },
  },
  primitive: {
    borderRadius: {
      none: '0',
      xs: '2px',
      sm: '4px',
      md: '4px',
      lg: '4px',
      xl: '4px',
    },

    slate: {
      50: '#f8fafc',
      100: '#f1f5f9',
      200: '#e2e8f0',
      300: '#cbd5e1',
      400: '#94a3b8',
      500: '#64748b',
      600: '#475569',
      700: '#334155',
      800: '#1e293b',
      900: '#0f172a',
      950: '#020617',
    },
    gray: {
      50: '#f9fafb',
      100: '#f3f4f6',
      200: '#e5e7eb',
      300: '#d1d5db',
      400: '#9ca3af',
      500: '#6b7280',
      600: '#4b5563',
      700: '#374151',
      800: '#1f2937',
      900: '#111827',
      950: '#030712',
    },
    zinc: {
      50: '#fafafa',
      100: '#f4f4f5',
      200: '#e4e4e7',
      300: '#d4d4d8',
      400: '#a1a1aa',
      500: '#71717a',
      600: '#52525b',
      700: '#3f3f46',
      800: '#27272a',
      900: '#18181b',
      950: '#09090b',
    },
    neutral: {
      50: '#fafafa',
      100: '#f5f5f5',
      200: '#e5e5e5',
      300: '#d4d4d4',
      400: '#a3a3a3',
      500: '#737373',
      600: '#525252',
      700: '#404040',
      800: '#262626',
      900: '#171717',
      950: '#0a0a0a',
    },
    stone: {
      50: '#fafaf9',
      100: '#f5f5f4',
      200: '#e7e5e4',
      300: '#d6d3d1',
      400: '#a8a29e',
      500: '#78716c',
      600: '#57534e',
      700: '#44403c',
      800: '#292524',
      900: '#1c1917',
      950: '#0c0a09',
    },
  },
  extend: {
    primitive: {
      lpprimary: {
        50: '#EDF7F7',
        100: '#D8EDEE',
        200: '#B4DCDF',
        300: '#8DCACE',
        400: '#6ABABE',
        500: '#49A3A8',
        600: '#3B8387',
        700: '#2B6164',
        800: '#1D4244',
        900: '#0E1F20',
        950: '#081112',
      },
      lpblue: {
        50: '#F1F8F9',
        100: '#E3F2F2',
        200: '#C3E2E4',
        300: '#A7D5D7',
        400: '#88C6C9',
        500: '#6BB8BC',
        600: '#499DA2',
        700: '#38787B',
        800: '#254F51',
        900: '#13292A',
        950: '#0A1415',
      },
      lporange: {
        50: '#FDF6ED',
        100: '#F9EBD7',
        200: '#F5D9B3',
        300: '#EFC58A',
        400: '#E9B162',
        500: '#E49D3B',
        600: '#CA811C',
        700: '#986215',
        800: '#67420E',
        900: '#312007',
        950: '#1B1104',
      },
      lpgreen: {
        50: '#F9F9F0',
        100: '#F0F3DE',
        200: '#E4E8C0',
        300: '#D5DB9E',
        400: '#C7CF7D',
        500: '#B9C35D',
        600: '#9DA73E',
        700: '#777E2F',
        800: '#505620',
        900: '#26290F',
        950: '#151608',
      },
      lpsand: {
        50: '#FEFDFB',
        100: '#FEFDFB',
        200: '#FBF8F4',
        300: '#F9F6F0',
        400: '#F8F3EC',
        500: '#F6F0E7',
        600: '#DCC5A2',
        700: '#C2995C',
        800: '#896733',
        900: '#46351A',
        950: '#21190D',
      },
      lpred: {
        50: '#FBEEF0',
        100: '#F7D9DC',
        200: '#F0B8BD',
        300: '#E7929B',
        400: '#E0707C',
        500: '#D84B59',
        600: '#C12A39',
        700: '#8F1F2A',
        800: '#60151C',
        900: '#2E0A0E',
        950: '#190507',
      },
      lpyellow: {
        50: '#FDFAF2',
        100: '#FBF5E5',
        200: '#F7EACA',
        300: '#F2E0B0',
        400: '#EED595',
        500: '#EACB7A',
        600: '#E0B23D',
        700: '#B98D1D',
        800: '#7B5E13',
        900: '#3E2F0A',
        950: '#1F1705',
      },
      lpgrey: {
        50: '#F6F6F3',
        100: '#EDECE8',
        200: '#DCD9D0',
        300: '#CAC6B9',
        400: '#B9B3A2',
        500: '#A69F89',
        600: '#8C8469',
        700: '#69634F',
        800: '#464235',
        900: '#23211A',
        950: '#11100D',
      },
      lpnougat: {
        50: '#F8F5F1',
        100: '#F2EAE4',
        200: '#E2D3C5',
        300: '#D5BFAA',
        400: '#C6A78B',
        500: '#B8926F',
        600: '#9D744D',
        700: '#78583B',
        800: '#4F3A27',
        900: '#291E14',
        950: '#150F0A',
      },
      lpturqoise: {
        50: '#F6F9F7',
        100: '#EDF3F0',
        200: '#DBE6E1',
        300: '#C9DAD2',
        400: '#B6CDC3',
        500: '#A6C2B5',
        600: '#7AA490',
        700: '#577F6C',
        800: '#3A5548',
        900: '#1D2A24',
        950: '#0F1512',
      },
      lprose: {
        50: '#FAF5F5',
        100: '#F6EEEF',
        200: '#ECDADC',
        300: '#E3C9CC',
        400: '#DBB8BC',
        500: '#D1A5AA',
        600: '#B8757C',
        700: '#954C54',
        800: '#623238',
        900: '#331A1D',
        950: '#180C0D',
      },
      lpdarkblue: {
        50: '#DEF5FC',
        100: '#B9E9F8',
        200: '#78D4F2',
        300: '#32BDEC',
        400: '#1397C4',
        500: '#0C637F',
        600: '#0A4F66',
        700: '#073A4B',
        800: '#052833',
        900: '#021217',
        950: '#010B0E',
      },
      lpolive: {
        50: '#F9F9F6',
        100: '#F1F1E9',
        200: '#E3E3D3',
        300: '#D7D6C1',
        400: '#CAC8AB',
        500: '#BCBA95',
        600: '#A29F6C',
        700: '#7D7B4F',
        800: '#515033',
        900: '#29281A',
        950: '#16150E',
      },
      lpmocha: {
        50: '#F4ECE6',
        100: '#E9D9CD',
        200: '#D3B49C',
        300: '#BE8E6A',
        400: '#9F6D46',
        500: '#6D4A30',
        600: '#593C27',
        700: '#402C1C',
        800: '#2B1D13',
        900: '#150F09',
        950: '#0B0705',
      },
    },
  },
});
